<div class="bigger-container">
  <div class="left-section">
    <p class="filter-title">Filtra</p>
    <form class="filters" [formGroup]="form">
      <div>
        <label for="status">Cerca per UID</label>
        <input type="text" formControlName="uid" placeholder="Cerca per UID" />
      </div>
      <div>
        <label for="status">Cerca per nome e cognome</label>
        <input
          type="text"
          formControlName="name"
          placeholder="Cerca per nome/cognome"
        />
      </div>
      <div>
        <label for="status">Cerca per email</label>
        <input
          type="text"
          formControlName="email"
          placeholder="Cerca per email"
        />
      </div>
      <div>
        <label for="status">Cerca per telefono</label>
        <input
          type="text"
          formControlName="phone"
          placeholder="Cerca per telefono"
        />
      </div>
      <div>
        <label>Ruolo</label>
        <select formControlName="role">
          <option default value="">TUTTI</option>
          <option value="ADMIN">ADMIN</option>
          <option value="FAMILYTUTOR">FAMILYTUTOR</option>
          <option value="USER">USER</option>
        </select>
      </div>

      <button class="reset-button" (click)="resetFilters()">RESET</button>
    </form>
  </div>
  <div class="right-section">
    <div class="smaller-container">
      <p class="smaller-text">Utenze Family Happy</p>
      <div class="smaller-bar"></div>
    </div>

    <div style="max-height: 70vh; overflow-y: auto">
      <table>
        <th>Nome</th>
        <th>Cognome</th>
        <th>Email</th>
        <th>Cellulare</th>
        <th>Ruolo</th>
        <th>Reset password</th>
        <th>Elimina</th>
        <tr
          *ngFor="let user of usersPage ? usersPage.content : []"
          (click)="goToDetails(user.uid)"
        >
          <td>{{ user.name | nullValuesTablePipe }}</td>
          <td>{{ user.surname | nullValuesTablePipe }}</td>
          <td>{{ user.email | nullValuesTablePipe }}</td>
          <td>{{ user.phone | nullValuesTablePipe }}</td>
          <td>
            <!-- If caregiver → TEXT -->
            <ng-container *ngIf="isCaregiver(user.role); else editableRole">
              {{ formatCaregiverRole(user.role) }}
            </ng-container>

            <!-- Otherwise → SELECT -->
            <ng-template #editableRole>
              <select
                [ngModel]="user.role"
                (click)="$event.stopPropagation()"
                (change)="changeUserRole(user, $event)"
              >
                <option value="USER">USER</option>
                <option value="FAMILYTUTOR">FAMILYTUTOR</option>
                <option value="ADMIN">ADMIN</option>
              </select>
            </ng-template>
          </td>
          <td style="text-align: center">
            <button
              type="button"
              class="email-button"
              stile="width:50px"
              (click)="$event.stopPropagation(); resetPassword(user.email)"
            >
              Invia email
            </button>
          </td>
          <td (click)="$event.stopPropagation(); deleteUser(user.uid)">
            <span class="action-btn action-delete" title="Elimina">
              <i class="bi bi-trash3" style="font-size: 15px"></i>
            </span>
          </td>
        </tr>
        <tr *ngIf="usersPage && usersPage.content.length === 0">
          <td colspan="7" style="text-align: center">
            Non sono state trovate utenze che soddisfano i criteri di ricerca.
          </td>
        </tr>
      </table>
    </div>

    <div class="table-footer">
      <div class="footer-count">
        <i class="bi bi-list-ul"></i>
        Sono presenti <b>{{ collectionSize }} utenze</b> nella lista
      </div>
      <div class="elements-limit-container">
        <label for="elements-number">Righe per pagina</label>
        <select id="elements-number" [formControl]="elementsPerPage">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
        <ngb-pagination
          *ngIf="usersPage && usersPage.content.length > 0"
          [maxSize]="5"
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="collectionSize"
          (pageChange)="onPageChange()"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>

<!--Alert section-->
<app-alert
  *ngIf="showAlert"
  (save)="onAlertConfirmation($event)"
  [data]="{ type: undefined }"
  [title]="'Attenzione!'"
  [message]="message"
>
</app-alert>
